import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { Modules } from "@lib/titan2/dist/game/Constants";
import { Point } from "pixi.js";
/**
 * AbstractGameSummaryCellProperties.ts
 */
export class GameMainTransitionProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    setDefaultValues() {
        this.transitionSpine = new SpineProperties("LiftTransition", Modules.GAME, new Point(973, 512));
    }
}
//# sourceMappingURL=GameMainTransitionProperties.js.map